<template>
  <div id="tenantMenuContainer">
    <v-menu
      v-model="isMenuOpen"
      attach="#tenantMenuContainer"
      offset-y
      transition="fade-transition"
      content-class="mt-2"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{on, attrs, value}">
        <div style="position: relative">
          <v-btn
            class="zoox-component zoox-descrete-select px-0"
            text
            :style="{
              'margin-top': xSmall ? '4px' : null,
              'min-width': xSmall ? '28px' : null,
            }"
            :small="!xSmall"
            :x-small="xSmall"
            :disabled="disabled"
            v-bind="attrs"
            v-on="on"
          >
            <!--@slot Slot para customização do item selecionado -->
            <slot name="selected">
              <span class="zoox-descrete-select-text">
                {{ currentValueText }}
              </span>
            </slot>
            <v-icon right dark> {{ openIcon }} </v-icon>
          </v-btn>

          <v-fade-transition>
            <div v-if="value" class="arrow-menu"></div>
          </v-fade-transition>
        </div>
      </template>

      <z-card width="100%" class="pt-4 pb-2">
        <template #content>
          <z-chip-tabs v-model="currentTab" :tabs="tabs">
            <template #all>
              <v-fade-transition hide-on-leave>
                <v-skeleton-loader
                  v-if="isLoading"
                  type="list-item-avatar@10"
                ></v-skeleton-loader>
              </v-fade-transition>
            </template>

            <template #groups>
              <z-input
                hide-details
                class="my-2"
                small
                rounded
                clearable
                :value="groupsSearch"
                @input="$emit('update:groups-search', $event || '')"
              >
                <template #label>
                  <z-icon size="15">$search_rounded</z-icon>

                  {{ $t('search_groups') }}
                </template>
              </z-input>

              <template>
                <v-list
                  nav
                  dense
                  style="background-color: unset"
                  :disabled="disabled"
                >
                  <v-list-item
                    v-if="!hideSelectAll"
                    :style="{color: isAllGroupsSelected ? 'var(--accent)' : ''}"
                    @click="onSelectAllGroups"
                  >
                    <v-list-item-content>
                      {{ $t('all_groups') }}
                    </v-list-item-content>

                    <v-list-item-action v-if="isAllGroupsSelected">
                      <z-icon color="var(--accent)" size="15">
                        $check_rounded
                      </z-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-divider class="mb-1"></v-divider>
              </template>

              <v-fade-transition hide-on-leave>
                <v-skeleton-loader
                  v-if="isLoading"
                  type="list-item-avatar@10"
                ></v-skeleton-loader>

                <z-scrollbar
                  v-else-if="groups.length > 0"
                  style="max-height: 200px"
                >
                  <nested-list
                    :disabled="disabled"
                    :value="value"
                    :nodes="groups"
                    :hide-favorite="hideFavorites"
                    @favorite="onFavorite"
                    @input="onSelectOption"
                  />
                </z-scrollbar>

                <div v-else class="empty-list-text">
                  {{ $t('empty_groups') }}
                </div>
              </v-fade-transition>
            </template>

            <template #companies>
              <z-input
                hide-details
                class="my-2"
                small
                rounded
                clearable
                :value="companiesSearch"
                @input="$emit('update:companies-search', $event || '')"
              >
                <template #label>
                  <z-icon size="15">$search_rounded</z-icon>

                  {{ $t('search_companies') }}
                </template>
              </z-input>

              <template>
                <v-list
                  nav
                  dense
                  style="background-color: unset"
                  :disabled="disabled"
                >
                  <v-list-item
                    v-if="!hideSelectAll"
                    :style="{
                      color: isAllCompaniesSelected ? 'var(--accent)' : '',
                    }"
                    @click="onSelectAllCompanies"
                  >
                    <v-list-item-content>
                      {{ $t('all_companies') }}
                    </v-list-item-content>

                    <v-list-item-action v-if="isAllCompaniesSelected">
                      <z-icon color="var(--accent)" size="15">
                        $check_rounded
                      </z-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <v-divider class="mb-1"></v-divider>
              </template>

              <template v-if="currentTab === 'companies'">
                <v-fade-transition hide-on-leave>
                  <v-skeleton-loader
                    v-if="isLoading"
                    type="list-item-avatar@10"
                  ></v-skeleton-loader>

                  <z-scrollbar
                    v-else-if="companies.length > 0"
                    style="max-height: 200px"
                  >
                    <v-list
                      nav
                      dense
                      style="background-color: unset"
                      :disabled="disabled"
                    >
                      <v-list-item-group
                        color="var(--accent)"
                        :mandatory="Boolean(value) && isValueInCompanies"
                        :value="value"
                        @change="onSelectOption"
                      >
                        <v-slide-x-transition group>
                          <v-list-item
                            v-for="item in companies"
                            :key="item.value"
                            :value="item.value"
                          >
                            <v-list-item-icon
                              v-if="!hideFavorites"
                              class="mr-2"
                            >
                              <z-icon
                                style="width: 100%"
                                size="15"
                                @click.stop="onFavorite(item)"
                              >
                                {{
                                  item.favorite === true
                                    ? '$star_rounded'
                                    : '$star'
                                }}
                              </z-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              {{ item.text }}
                            </v-list-item-content>

                            <v-list-item-action v-if="value === item.value">
                              <z-icon size="15"> $check_rounded </z-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-slide-x-transition>
                      </v-list-item-group>
                    </v-list>
                  </z-scrollbar>

                  <div v-else class="empty-list-text">
                    {{ $t('empty_companies') }}
                  </div>
                </v-fade-transition>
              </template>
            </template>

            <template #favorites>
              <z-input
                hide-details
                class="my-2"
                small
                rounded
                clearable
                :value="favoritesSearch"
                @input="$emit('update:favorites-search', $event || '')"
              >
                <template #label>
                  <z-icon size="15">$search_rounded</z-icon>

                  {{ $t('search_favorites') }}
                </template>
              </z-input>

              <template v-if="currentTab === 'favorites'">
                <v-fade-transition hide-on-leave>
                  <z-scrollbar
                    v-if="favorites.length > 0"
                    style="max-height: 200px"
                  >
                    <v-list nav dense style="background-color: unset">
                      <v-list-item-group
                        color="var(--accent)"
                        :mandatory="Boolean(value) && isValueInFavorites"
                        :value="value"
                        @change="onSelectOption"
                      >
                        <v-slide-x-reverse-transition group>
                          <v-list-item
                            v-for="item in favorites"
                            :key="item.value"
                            :value="item.value"
                          >
                            <v-list-item-icon class="mr-2">
                              <z-icon
                                style="width: 100%"
                                size="15"
                                @click.stop="onFavorite(item)"
                                >$star_rounded</z-icon
                              >
                            </v-list-item-icon>

                            <v-list-item-content>
                              <div class="d-flex align-center">
                                {{ item.text }}

                                <z-icon
                                  v-if="
                                    itemIsInGroupOrCompany(item) === 'groups'
                                  "
                                  class="ml-2"
                                  size="15"
                                >
                                  $domain
                                </z-icon>

                                <z-icon
                                  v-if="
                                    itemIsInGroupOrCompany(item) === 'companies'
                                  "
                                  class="ml-2"
                                  size="15"
                                >
                                  $business_center_rounded
                                </z-icon>
                              </div>
                            </v-list-item-content>

                            <v-list-item-action v-if="value === item.value">
                              <z-icon size="15"> $check_rounded </z-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-slide-x-reverse-transition>
                      </v-list-item-group>
                    </v-list>
                  </z-scrollbar>

                  <div v-else class="empty-list-text">
                    {{ $t('empty_favorites') }}
                  </div>
                </v-fade-transition>
              </template>
            </template>
          </z-chip-tabs>
        </template>
      </z-card>
    </v-menu>
  </div>
</template>

<script>
import NestedList from './private/NestedList.vue'
/**
 * @displayName Descrete Select
 */
export default {
  name: 'ZTenantMenuSelector',
  components: {
    NestedList,
  },

  i18n: {
    messages: {
      en: {
        all: 'All',
        groups: 'Groups',
        companies: 'Companies',
        favorites: 'Favorites',
        search_groups: 'Search groups',
        search_companies: 'Search companies',
        search_favorites: 'Search favorites',
        empty_groups: 'There are no groups to select',
        empty_companies: 'There are no companies to select',
        empty_favorites: 'There are no favorites to select',
        all_groups: 'All groups',
        all_companies: 'All companies',
      },
      pt: {
        all: 'Todos',
        groups: 'Grupos',
        companies: 'Empresas',
        favorites: 'Favoritos',
        search_groups: 'Buscar grupos',
        search_companies: 'Buscar empresas',
        search_favorites: 'Buscar favoritos',
        empty_groups: 'Não há grupos para selecionar',
        empty_companies: 'Não há empresas para selecionar',
        empty_favorites: 'Não há favoritos para selecionar',
        all_groups: 'Todos os grupos',
        all_companies: 'Todas as empresas',
      },
      es: {
        all: 'Todos',
        groups: 'Grupos',
        companies: 'Empresas',
        favorites: 'Favoritos',
        search_groups: 'Buscar grupos',
        search_companies: 'Buscar empresas',
        search_favorites: 'Buscar favoritos',
        empty_groups: 'No hay grupos para seleccionar',
        empty_companies: 'No hay empresas para seleccionar',
        empty_favorites: 'No hay favoritos para seleccionar',
        all_groups: 'Todos los grupos',
        all_companies: 'Todas las empresas',
      },
      fr: {
        all: 'Tous',
        groups: 'Groupes',
        companies: 'Sociétés',
        favorites: 'Favoris',
        search_groups: 'Rechercher des groupes',
        search_companies: 'Rechercher des sociétés',
        search_favorites: 'Rechercher des favoris',
        empty_groups: 'Aucun groupe à sélectionner',
        empty_companies: 'Aucune société à sélectionner',
        empty_favorites: 'Aucun favori à sélectionner',
        all_groups: 'Tous les groupes',
        all_companies: 'Toutes les sociétés',
      },
      tr: {
        all: 'Hepsi',
        groups: 'Gruplar',
        companies: 'Şirketler',
        favorites: 'Favoriler',
        search_groups: 'Grupları Ara',
        search_companies: 'Şirketleri Ara',
        search_favorites: 'Favorileri Ara',
        empty_groups: 'Seçilecek grup yok',
        empty_companies: 'Seçilecek şirket yok',
        empty_favorites: 'Seçilecek favori yok',
        all_groups: 'Tüm gruplar',
        all_companies: 'Tüm şirketler',
      },
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Select label
     */
    label: {
      type: String,
      required: false,
      default: '',
    },

    /**
     * Selected value
     *
     * @modelName value
     */
    value: {
      type: [String, Number],
      required: false,
      default: '',
    },
    /**
     * Flag para desabilitar o select
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * Flag para adicionar o ícone de abrir o select
     */
    openIcon: {
      type: String,
      default: '$keyboard_arrow_down_rounded',
    },
    /**
     * Flag para aplicar estilo de select pequeno
     */
    xSmall: {
      type: Boolean,
      default: false,
    },

    /**
     * Array de grupos
     * @property {String, Number} id - Id único do grupo
     * @property {String} text - Texto a ser exibido quando o grupo for selecionado
     * @property {String} value - Valor a ser retornado quando o grupo for selecionado
     * @property {Boolean} favorite - Flag para indicar se o grupo é favorito
     */
    groups: {
      type: Array,
      required: false,
    },

    /**
     * Array de empresas
     * @property {String, Number} id - Id único da company
     * @property {String} text - Texto a ser exibido quando a empresa for selecionada
     * @property {String} value - Valor a ser retornado quando a empresa for selecionada
     * @property {Boolean} favorite - Flag para indicar se a empresa é favorita
     */
    companies: {
      type: Array,
      required: false,
    },

    /**
     * Valor do input de busca de grupos
     */
    groupsSearch: {
      type: String,
      required: false,
      default: '',
    },

    /**
     * Valor do input de busca de empresas
     */
    companiesSearch: {
      type: String,
      required: false,
      default: '',
    },

    /**
     * Valor do input de busca de favoritos
     */
    favoritesSearch: {
      type: String,
      required: false,
      default: '',
    },

    /**
     * Flag para indicar o componente está em estado de loading
     */
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Flag para esconder a aba de grupos
     */
    hideGroups: {
      type: Boolean,
      required: false,
      default: false,
    },

    hideCustomTabAll: {
      type: Boolean,
      required: false,
      default: true,
    },

    /**
     * Flag para esconder a aba de empresas
     */
    hideCompanies: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Flag para esconder o selecionar todos
     */
    hideSelectAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para esconder a aba de favoritos
     */

    hideFavorites: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isMenuOpen: false,
      currentTab: 'groups',
      isAllGroupsSelected: false,
      isAllCompaniesSelected: false,
    }
  },

  computed: {
    tabs() {
      const tabs = []

      if (!this.hideCustomTabAll) {
        tabs.push({id: 'all', text: this.$t('all'), icon: '$toc_rounded'})
      }

      if (!this.hideGroups) {
        tabs.push({id: 'groups', text: this.$t('groups'), icon: '$domain'})
      }

      if (!this.hideCompanies) {
        tabs.push({
          id: 'companies',
          text: this.$t('companies'),
          icon: '$business_center_rounded',
        })
      }

      if (!this.hideFavorites) {
        tabs.push({
          id: 'favorites',
          text: this.$t('favorites'),
          icon: '$star_rounded',
        })
      }

      return tabs
    },
    currentValueText() {
      if (this.isAllGroupsSelected && this.currentTab === 'groups') {
        return this.$t('all_groups')
      }

      if (this.isAllCompaniesSelected && this.currentTab === 'companies') {
        return this.$t('all_companies')
      }

      const selectedInGroup = this.findRecursive(this.groups, this.value)
      if (selectedInGroup) {
        return selectedInGroup?.text || this.label || ''
      }

      const selectedCompany = this.companies.find(
        (item) => item.value === this.value
      )
      return selectedCompany?.text || this.label || ''
    },

    favorites() {
      const groups = this.filterRecursive(this.groups, {
        itemKey: 'favorite',
        term: true,
      })

      const companies = this.companies.filter((item) => item.favorite === true)

      return [...groups, ...companies]
    },

    isValueInCompanies() {
      return (
        this.companies.findIndex((item) => item.value === this.value) !== -1
      )
    },

    isValueInFavorites() {
      return (
        this.favorites.findIndex((item) => item.value === this.value) !== -1
      )
    },
  },

  watch: {
    currentTab(val) {
      this.$emit('update:current-tab', val)
    },
    isMenuOpen(isVisible) {
      this.$emit('update:opened', isVisible)
    },
    value: {
      immediate: true,
      handler(val) {
        if (val === 'all') {
          this.isAllGroupsSelected = true
          this.isAllCompaniesSelected = true
          return
        }

        this.isAllGroupsSelected = false
        this.isAllCompaniesSelected = false
      },
    },
  },

  methods: {
    onSelectOption(value) {
      /**
       * Emitido quando há alteração no valor
       * @emit change
       * @param {String} option - Valor da opção selecionada
       */

      if (value) {
        this.$emit('change', value, this.currentTab)
        this.isMenuOpen = false
      }
    },

    onSelectAllGroups() {
      this.$emit('change', 'all', this.currentTab)
      this.isMenuOpen = false

      this.$nextTick(() => {
        this.isAllGroupsSelected = true
      })
    },

    onSelectAllCompanies() {
      this.$emit('change', 'all', this.currentTab)
      this.isMenuOpen = false

      this.$nextTick(() => {
        this.isAllCompaniesSelected = true
      })
    },

    onFavorite(item) {
      const currentTab = this.currentTab

      if (currentTab === 'favorites') {
        //procura o item no array de grupos de forma recursiva, se baseando na chave children
        const isInGroups = Boolean(this.findRecursive(this.groups, item.value))

        const isInCompanies =
          this.companies.findIndex((i) => i.value === item.value) !== -1

        if (isInGroups) {
          this.$emit('remove-favorite', item, 'groups')
        }

        if (isInCompanies) {
          this.$emit('remove-favorite', item, 'companies')
        }

        return
      }

      if (item.favorite) {
        this.$emit('remove-favorite', item, currentTab)
      } else {
        this.$emit('add-favorite', item, currentTab)
      }
    },

    itemIsInGroupOrCompany(item) {
      const isInGroups = Boolean(this.findRecursive(this.groups, item.value))

      const isInCompanies =
        this.companies.findIndex((i) => i.value === item.value) !== -1

      if (isInGroups) return 'groups'
      if (isInCompanies) return 'companies'
    },

    findRecursive(arr, term) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === term) {
          return arr[i]
        }

        if (arr[i].children) {
          const found = this.findRecursive(arr[i].children, term)
          if (found) {
            return found
          }
        }
      }

      return null
    },

    filterRecursive(arr, {itemKey, term}) {
      let matches = []

      if (!Array.isArray(arr)) {
        return matches
      }

      for (let i of arr) {
        if (i[itemKey] === term) {
          matches.push(i)
        }

        if (i.children) {
          let childResults = this.filterRecursive(i.children, {itemKey, term})
          if (childResults.length) {
            matches.push(...childResults)
          }
        }
      }

      return matches
    },
  },
}
</script>

<style lang="scss" scoped>
// CUSTOMIZAÇÃO VUETIFY
:deep(.v-skeleton-loader__list-item-avatar) {
  height: 20px !important;
}

:deep(.v-skeleton-loader__avatar) {
  width: 15px !important;
  height: 15px !important;
}

:deep(.v-input--checkbox *) {
  font-size: 13px !important;
}

:deep(.v-list--disabled) {
  opacity: 0.5;
}

.v-list {
  padding: 0 !important;
}

// CUSTOMIZAÇÃO DO COMPONENTE
.zoox-descrete-select-text {
  font-family: 'Roboto', sans-serif;
  text-transform: initial;
  font-size: 0.875rem;
  font-weight: 400;
}

.arrow-menu {
  transform: translateX(-50%);
  position: absolute;
  border-bottom: solid 8px var(--white) !important;
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  top: 28px;
  left: 50%;
  height: 0px;
  width: 0px;
  z-index: 9;
}

.empty-list-text {
  margin: 50px 0;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  line-height: 15px;
  color: var(--black-600);
}
</style>
